import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatSliderModule } from '@angular/material/slider';
import { MainMenuModule } from '../main-menu/main-menu.module';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { CategoriesModule } from '../categories/categories.module';
import { AppRoutingModule } from '../../app-routing.module';
import { SubcategoryComponent } from './subcategory.component';
import { MatCardModule } from '@angular/material/card';
import { ParentCardModule } from '../parent-card/parent-card.module';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [
    SubcategoryComponent
  ],
  imports: [
    AppRoutingModule,
    CommonModule,
    MatSliderModule,
    MainMenuModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatIconModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    CategoriesModule,
    MatCardModule,
    ParentCardModule,
    RouterModule
  ],
  exports: [
    SubcategoryComponent,
    RouterModule
  ]
})
export class SubcategoriesModule { }
